import { action, computed, makeObservable, observable } from 'mobx';
import { YesNoState } from '@alfa-retail-react/components/yes-no-question';

import { CardProduct } from 'app/model/product/CardProduct';
import { InsuranceListStore } from 'app/logic/pages/productParametersConfigure/InsuranceListStore';
import { InsuranceProduct } from 'app/model/product/InsuranceProduct';

export class IntroductionFormStore {
    @observable
    insuranceStore: InsuranceListStore;

    personalNumber: string;

    phone: string;

    @observable
    creditLimit: string;

    @observable
    insuranceProduct: InsuranceProduct;

    @observable
    private _insuranceAppliedState: YesNoState;

    @observable
    private _cardProduct: CardProduct;

    @computed
    get availableInsuranceList() {
        return this.insuranceStore.sortedInsuranceList.filter(
            (insuranceProduct) => {
                return (
                    insuranceProduct.minCreditAmount <= Number(this.creditLimit)
                );
            },
        );
    }

    @computed
    get defaultInsurance() {
        return this.hasAvailableInsurance
            ? this.availableInsuranceList[0]
            : this.insuranceStore.minAmountInsuranceProducts[0];
    }

    @computed
    get hasAvailableInsurance(): boolean {
        return !!this.availableInsuranceList.length;
    }

    @computed
    get hasAppliedInsurance() {
        return this._insuranceAppliedState === YesNoState.YES;
    }

    @computed
    get insuranceAppliedState() {
        return this._insuranceAppliedState;
    }

    @action
    setInsurance(insurance: InsuranceProduct) {
        this.insuranceProduct = insurance;
    }

    @action
    setCreditLimit(limit: string) {
        this.creditLimit = limit;
    }

    constructor(cardProduct: CardProduct) {
        makeObservable(this);

        this._cardProduct = cardProduct;
        this.insuranceStore = new InsuranceListStore(cardProduct.insurance);
        this.creditLimit = String(cardProduct.maxAmount);
        this.setInsurance(this.defaultInsurance);
    }

    static default(cardProduct: CardProduct) {
        return new IntroductionFormStore(cardProduct);
    }
}
